module.exports = __webpack_public_path__ + "img/step4.ba020beb.png";